"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ListViewLevel;
    }
});
let ListViewLevel = class ListViewLevel {
    static async get(..._args) {
        return null;
    }
    static async list(..._args) {
        return [];
    }
    static async insert(..._args) {
        return null;
    }
    static async update(..._args) {
        return null;
    }
    static async delete(..._args) {
        return null;
    }
    static async bulkInsertOrUpdate(..._args) {
        return [];
    }
    constructor(data){
        Object.assign(this, data);
    }
};
